import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import moment from 'moment';
import axios from 'axios';
import Api from "../Api/Api.json";
import BottomTab from './BottomTab';



var userid=0;

const CheckIdlePatients = () => {
  const [initialized, setInitialized] = useState(false);
  const [hasCC, setHasCC] = useState(false);
  const [ccTableData,setCCTableData]=useState([{}]);
  const [audioPath,setAudioPath]=useState("");
  const [playing,setPlaying]=useState(false);
  const [text,setText]=useState("");
  const navigate=useNavigate();
  //setText(local_apk_version);
  useEffect(()=>{

    const headers = { headers: { "Content-Type": "application/json" } }
    const url = Api.TELEDOC_PROVIDER_API;
    const requestData = {
      task: 'getIdleDataPatientList'
    };

    axios.post(url,requestData,headers)
    .then(response=>{
      //console.log(response.data)
      if (response.data.length > 0){
        setCCTableData(response.data)
      }
    })
    .catch(error=>{
      console.log(error)
    });

  },[]);
  
const submitComment=(item)=>{
  const comment = document.getElementById(item.name).value;
    // Check if the comment is empty
    if (!comment) {
      alert('Please enter a comment');
      return;
    }

    const headers = { headers: { "Content-Type": "application/json" } }
    const url = Api.TELEDOC_PROVIDER_API;
    const requestData = {
      task: 'createPatientNotes',
      patient_id:item.id,
      idle_data_note:comment,
    };
    axios.post(url,requestData,headers)
    .then(response=>{
      //console.log(response.data)
    })
    .catch(error=>{
      console.log(error)
    });

};

const showComment=(item)=>{

  const headers = { headers: { "Content-Type": "application/json" } }
  const url = Api.TELEDOC_PROVIDER_API;
  const requestData = {
    task: 'getPatientNotes',
    patient_id:item.id,
    idle_data_note:true,
  };
  axios.post(url,requestData,headers)
  .then(response=>{
    //console.log(response.data)
    if(response.data.length>0)
      {
        const btn = document.getElementById('b_' + item.name);
        if(btn){
          btn.textContent = response.data[0].timestamp+' : '+response.data[0].note;
        }
      }
  })
  .catch(error=>{
    console.log(error)
  });

};

  return (
    <div>
    <p>Idle Data Patient List:</p>
      
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Phone</th>
            <th>Write Comment</th>
            <th>Show Comment</th>
          </tr>
        </thead>
        <tbody>
          {ccTableData.map((item) => (
            <tr key={item.id}>
              <td>{item.name}</td>
              <td>{item.phone}</td>
              <td>
               <input type="text" id={item.name} />
                <button onClick={() => submitComment(item)}>Submit</button>
              </td>
              <td>
                <button id={'b_'+item.name} onClick={() => showComment(item)}>Show</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>      

        <BottomTab />
     </div>
    //</div>
  );
};

export default CheckIdlePatients;